import React, { useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Container } from "../../common/layout/styels";
import { MenuGroupItem } from "../settings/styels";
import { Button } from "../../../elements/list/popup/styles";
import { useNavigate } from "react-router-dom";
// import withLayout from "../../../public/layout";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 2rem 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const LeftColumn = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 20px;
  max-width: 768px;
`;

const RightColumn = styled.div`
  flex: 1;
  background: #f9f9f9;
  border-left: 4px solid #3FC4FD;
  padding: 1.5rem;
  font-style: italic;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Heading = styled.h2`
  margin: 0;
  margin-bottom: 0.5rem;
  color: #222;
`;

const Heading2 = styled.h3`
  margin: 0;
  // margin-top: 20px;
  color: #0000aaff;
  text-transform: uppercase;
`;

const SubHeading = styled.h3`
  margin-bottom: 1rem;
  margin-top: 0;
  font-weight: 700;
//   color: #3FC4FD;
`;

const Paragraph = styled.p`
  margin: 0;
  line-height: 1.6;
`;

const Link = styled.a`
  color: #000000;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #3FC4FD;
  }
`;

const HelpAndSupport = (props) => {
  const { t } = useTranslation();
  const [user] = useState(props.user.user);
  const navigate = useNavigate();

  return (
    <Container className="noshadow column" style={{padding: '0'}}>
    
        <LeftColumn>
          <Heading2>{t("HELP & SUPPORT")}</Heading2>
          <Heading>{t("How can we help you?")}</Heading>
          <Paragraph>
            {t("Find answers or contact our expert team; we're happy to help.")}
          </Paragraph>

<Wrapper>
          <MenuGroupItem className="support">
            <SubHeading>{t("Frequently Asked Questions")}(FAQ)</SubHeading>
            <Paragraph>{t("Answers to frequently asked questions about features, login, and setup")}</Paragraph>
            <Button onClick={()=> navigate(user.authorisation==="partner" && user.partner ? '/partner/faq' : '/faq')} style={{marginTop: '30px', textDecoration: 'none', backgroundColor: "#3FC4FD", width: 'fit-content'}}>
              {t("Open FAQ")}
            </Button>
          </MenuGroupItem>

          <MenuGroupItem className="support">
            <SubHeading>{t("Contact Support")}</SubHeading>
            <Paragraph>{t("For billing, account issues, and support with individual questions.")}</Paragraph>
            <Button onClick={()=> navigate(user.authorisation==="partner" && user.partner ? '/partner/support' :'/support')} style={{marginTop: '30px', textDecoration: 'none', backgroundColor: "#3FC4FD", width: 'fit-content'}}>
              {t("Get in touch")}
            </Button>
          </MenuGroupItem>

          </Wrapper>

        </LeftColumn>

    </Container>
  );
};

export default Layout(HelpAndSupport);
